<template>
  <div>
    <partnerSchedule
      :partners="partners"
      :programPartnerSchedules="programPartnerSchedules"
      :programs="programs"
      @getPrgPartnerSchedule="getPrgPartnerSchedule"
    />
  </div>
</template>

<script>
import partnerSchedule from "@/components/link/schedule.vue";

export default {
  components: { partnerSchedule },
  data() {
    return {
      programPartnerSchedules: [],
      programs: [],
      partners: [],
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [
      { text: "Partner Admission Schedule" },
    ]);
    this.initialise();
  },
  methods: {
    goToPartnerView(id) {
      this.$router.push({ name: "View Add-on Programme Referral", params: { id } });
    },
    async initialise() {
      await Promise.all([
        this.getPrgPartnerSchedule(),
        this.getPrograms(),
        this.getPartners(),
      ]);
    },
    async getPartners() {
      await this.$axios
        .get("partners")
        .then((res) => {
          this.partners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrograms() {
      await this.$axios
        .get("programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrgPartnerSchedule() {
      await this.$axios
        .get("batch_partner_schedules")
        .then((res) => {
          const schedules = res.data.data;
          this.programPartnerSchedules = schedules.sort((a, b) => b.id - a.id);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
